import { render, staticRenderFns } from "./DeviceBeaconEditForm.vue?vue&type=template&id=6073a61f&scoped=true&"
import script from "./DeviceBeaconEditForm.vue?vue&type=script&lang=js&"
export * from "./DeviceBeaconEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6073a61f",
  null
  
)

export default component.exports